import * as React from 'react';
import { useState, useEffect } from 'react';

import { Header, SpaceBetween, Spinner } from '@amzn/awsui-components-react-v3';
import { GetRequestContextResponse, UserRequestContext } from 'aws-sdk/clients/awsdatalakegladstonelambda';
import { getRequestContext } from 'src/api/permissions';
import { RequestContextDetail } from 'src/components/datausageagreement/requestContextDetail';

export interface RequestContextDetailPageProps {
  setContentType: any;
  match: any;
  activeGroup: string;
  activeWorkspace?: any;
  userInfo?: any;
  dataAgreementId?: string;
}

export const RequestContextDetailPage = (props: RequestContextDetailPageProps) => {
  const [loading, setLoading] = useState(true);

  const [requestContext, setRequestContext] = useState<UserRequestContext>(undefined);

  useEffect(() => {
    props.setContentType('form');
    handleRefresh();
  }, []);

  const handleRefresh = async () => {
    setLoading(true);
    try {
      const requestContextId = props.match.params.id;
      const getRequestContextResponse: GetRequestContextResponse = await getRequestContext({
        id: requestContextId,
      });
      const requestContext: UserRequestContext = getRequestContextResponse.userRequestContext;
      setRequestContext(requestContext);
    } catch (e) {
      setRequestContext(undefined);
    }
    setLoading(false);
  };

  if (loading) {
    return <Spinner />;
  }

  return (
    <SpaceBetween size={'m'} direction={'vertical'}>
      <Header variant={'h1'} description={`Request context ID: ${requestContext?.requestContextId}`}>
        Request context
      </Header>
      <RequestContextDetail
        {...props}
        displayMetadataContainer={true}
        displaySaveButton={true}
        setContentType={props.setContentType}
        match={props.match}
        activeGroup={props.activeGroup}
        requestContext={requestContext}
        setRequestContext={setRequestContext}
        dataAgreementId={requestContext.requestSchema.dataAgreementId}
        omniContext={{}} // no Omni context is needed since the request has already been submitted - no need to autofill it.
      />
    </SpaceBetween>
  );
};
